// Shim to simplify importing of dotjem-routing
import 'angular-routing/build/angular-routing';
// Expose the module name
export default 'dotjem.routing';
